/**
 * 최근에 첫 비교 상대로 나온 가게를 기억해 둔다.
 *
 * 왜 필요한가
 * -----------
 * 첫 상대는 이진탐색 정확도 때문에 목록 정중앙 ±2칸에서만 고른다. 그런데
 * '좋아' 존의 레스토랑이 109곳이면 후보가 5곳뿐이라, 기록할 때마다 같은
 * 가게가 나온다. 거기에 '같은 종류 우선'까지 겹치면 사실상 한 곳으로 굳는다.
 *
 * 창을 넓히면 마지막 등수가 부정확해지므로(실측 오차 0.142 → 0.174),
 * 창은 그대로 두고 **최근에 나온 곳만 잠시 빼서** 나머지 중에서 고른다.
 * 정확도를 한 푼도 내주지 않고 반복만 없앤다.
 *
 * 저장 위치
 * --------
 * 이 기억은 기기 안에서만 의미가 있다(서버에 둘 이유가 없다). localStorage를
 * 쓰되, 못 쓰는 환경에서도 기록이 막히면 안 되므로 실패는 조용히 넘긴다.
 *
 * 인덱스가 아니라 placeId로 기억한다. 목록은 기록할 때마다 바뀌어서
 * 같은 인덱스가 다른 가게를 가리키기 때문이다.
 */

/** 존·카테고리마다 최근 몇 곳까지 빼둘지. 창이 5칸이라 이보다 키우면 뺄 게 없어진다 */
const KEEP = 3

const keyOf = (categoryId: number | string, zone: number) =>
  `zone-pivot-recent:${categoryId}:${zone}`

/** 최근 첫 상대로 쓰인 placeId들 (최신순) */
export function getRecentPivots(
  categoryId: number | string,
  zone: number
): number[] {
  try {
    const raw = localStorage.getItem(keyOf(categoryId, zone))
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === 'number') : []
  } catch {
    return []
  }
}

/** 이번에 쓴 첫 상대를 기억한다. 오래된 것부터 밀려난다 */
export function rememberPivot(
  categoryId: number | string,
  zone: number,
  placeId: number
): void {
  try {
    const next = [placeId, ...getRecentPivots(categoryId, zone).filter((v) => v !== placeId)]
    localStorage.setItem(keyOf(categoryId, zone), JSON.stringify(next.slice(0, KEEP)))
  } catch {
    /* 저장 못 해도 기록은 계속돼야 한다 */
  }
}
